"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBreakpoint = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _CarrierLogo = _interopRequireDefault(require("../CarrierLogo"));

var _SectionTile = _interopRequireDefault(require("../SectionTile"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Label = _interopRequireDefault(require("../Label"));

var _Stopover = _interopRequireWildcard(require("../Stopover"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _JourneySegment = _interopRequireDefault(require("./JourneySegment.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var SegmentContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__SegmentContainer",
  componentId: "sc-wq7a3z-0"
})(["width:100%;"]);

var SegmentHeader = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__SegmentHeader",
  componentId: "sc-wq7a3z-1"
})([""]);

var SegmentHeaderText = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__SegmentHeaderText",
  componentId: "sc-wq7a3z-2"
})(["display:flex;"]);

var SegmentBody = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__SegmentBody",
  componentId: "sc-wq7a3z-3"
})(["display:flex;align-items:center;"]);

var SegmentDurationStops = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__SegmentDurationStops",
  componentId: "sc-wq7a3z-4"
})(["display:flex;margin-left:3.75%;flex:0 0 44.915%;align-self:center;"]);

var Logo = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__Logo",
  componentId: "sc-wq7a3z-5"
})(["display:flex;flex:0 0 5.9%;margin-right:3.475%;"]);

var FromTo = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__FromTo",
  componentId: "sc-wq7a3z-6"
})(["display:flex;flex:0 0 39%;justify-content:space-between;"]);

var RenderFromTo = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__RenderFromTo",
  componentId: "sc-wq7a3z-7"
})(["display:flex;flex:0 0 7.09%;align-self:center;justify-content:center;"]);

var RenderStops = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__RenderStops",
  componentId: "sc-wq7a3z-8"
})(["display:flex;align-self:center;justify-content:center;"]);

var Duration = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__Duration",
  componentId: "sc-wq7a3z-9"
})(["display:flex;flex:0 0 25%;justify-content:center;"]);

var DetailedStops = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__DetailedStops",
  componentId: "sc-wq7a3z-10"
})(["display:flex;flex:0 0 75%;flex-wrap:wrap;"]);

var ToolTipContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__ToolTipContainer",
  componentId: "sc-wq7a3z-11"
})(["display:block;height:18px;"]);

var ToolTipIcon = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__ToolTipIcon",
  componentId: "sc-wq7a3z-12"
})(["display:block;"]);

var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "JourneySegment__ToolTipContent",
  componentId: "sc-wq7a3z-13"
})(["display:flex;flex-flow:column wrap;font-family:", ";font-weight:", ";font-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize.XSmall;
});

var getUniqueCarriers = function getUniqueCarriers(translation, carriers) {
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATIONS), translation);

  var uniqueCarriers = (0, _toConsumableArray2.default)(new Set(carriers.map(function (carrier) {
    return carrier.operatingCarrierName && carrier.operatingCarrierName !== carrier.marketingCarrierName ? "".concat("".concat(carrier.marketingCarrierName, " (").concat(language.operatedBy || _constant2.TRANSLATIONS.operatedBy, " ").concat(carrier.operatingCarrierName, ")")) : "".concat(carrier.marketingCarrierName);
  })));
  return uniqueCarriers;
};

var generateHeaderText = function generateHeaderText(_ref4) {
  var carriers = _ref4.carriers,
      tripType = _ref4.tripType,
      depart = _ref4.depart,
      translation = _ref4.translation;

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATIONS), translation);

  var uniqueCarriers = getUniqueCarriers(translation, carriers);
  var excessCarriers = uniqueCarriers.length - 3;
  var carrierText = uniqueCarriers.slice(0, 3).join(', ');

  if (tripType === _constant2.TRIP_TYPES.oneway) {
    return "".concat(depart ? language.depart : language.return, ": ").concat(carrierText);
  }

  return "".concat(depart ? language.depart : language.return, ": ").concat(carrierText, " ").concat(excessCarriers > 0 ? "(+".concat(excessCarriers, ")") : '');
};

var convertUtcToGmt = function convertUtcToGmt(utcDate) {
  var useLocalTimezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var dateObj = new Date(utcDate); // new Date converts utcDate to local timezone
  // if useLocalTimezone is true
  // return and use dateObj which is already using client's browser timezone

  if (useLocalTimezone) {
    return dateObj;
  }

  var gmtDate = new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate(), dateObj.getUTCHours(), dateObj.getUTCMinutes(), dateObj.getUTCSeconds(), dateObj.getUTCMilliseconds());
  return gmtDate;
};

var convertSecToHr = function convertSecToHr(seconds) {
  var hrs = seconds / 3600;
  var hour = Math.floor(hrs);
  var minute = Math.round((hrs - hour) * 60);
  return {
    hour: hour,
    minute: minute
  };
};

var getDurationFromSegments = function getDurationFromSegments(segment) {
  var totalDuration = 0;
  segment.map(function (seg) {
    totalDuration += seg.duration;
    totalDuration += seg.layoverTime ? seg.layoverTime : 0;
    return totalDuration;
  });
  return totalDuration;
};

var renderFromTo = function renderFromTo(hourCycle, designation, isTo, accessible, locale, useLocalTimezone) {
  var unsetPaddingLeft = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var unifiedConfirmationPageProp = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var title = "".concat(new Date(!isTo ? convertUtcToGmt(designation.departureTime, useLocalTimezone) : convertUtcToGmt(designation.arrivalTime, useLocalTimezone)).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: hourCycle !== 24
  }));
  var subtitleLowerCase = !isTo && designation ? designation.departureStation + (unifiedConfirmationPageProp ? " ".concat(designation.departureGMT) : '') : designation.arrivalStation + (unifiedConfirmationPageProp ? " ".concat(designation.arrivalGMT) : '');
  var subtitle = subtitleLowerCase ? subtitleLowerCase.toUpperCase() : null;
  /* istanbul ignore next */

  return /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    disableActiveState: true,
    hoverBackgroundColor: "default",
    subtitle: subtitle,
    subtitleColor: "greyDark",
    theme: "AIRASIA_CLASSIC",
    title: title,
    titleColor: "neutral",
    subtitleType: "small",
    bold: true,
    subtitleTextAlign: isTo ? 'right' : 'left',
    value: subtitle,
    unsetPaddingLeft: unsetPaddingLeft,
    width: unifiedConfirmationPageProp ? '45px' : 'auto',
    unifiedConfirmationPageProp: true
  });
};

var renderSegmentsToDuration = function renderSegmentsToDuration(segments, translation) {
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATIONS), translation);

  if (segments.length > 2) {
    return "".concat([{
      station: segments[1].designator.departureStation,
      layoverTime: segments[1].layoverTime
    }, {
      station: segments[2].designator.departureStation,
      layoverTime: segments[2].layoverTime
    }].map(function (seg) {
      var _convertSecToHr = convertSecToHr(seg.layoverTime),
          hour = _convertSecToHr.hour,
          minute = _convertSecToHr.minute;

      var duration = _utilities.default.constructDuration(hour, minute, language);

      return language.stopAt.replace('{0}', duration).replace('{1}', seg.station);
    }).join(', '), "  ").concat(segments.length > 3 ? " (+".concat(segments.length - 3, ")") : '');
  }
  /* istanbul ignore next */


  if (segments.length === 2) {
    var _convertSecToHr2 = convertSecToHr(segments[1].layoverTime),
        hour = _convertSecToHr2.hour,
        minute = _convertSecToHr2.minute;

    var duration = _utilities.default.constructDuration(hour, minute, language);

    return language.stopAt.replace('{0}', duration).replace('{1}', segments[0].designator.arrivalStation);
  }
  /* istanbul ignore next */


  return null;
};

var setBreakpoint = function setBreakpoint(bp) {
  if (bp <= parseInt(_constant.BREAKPOINTS.SMALL_TABLET.replace('px', ''), 10)) {
    return true;
  }

  return false;
};

exports.setBreakpoint = setBreakpoint;

var JourneySegment = function JourneySegment(_ref5) {
  var accessible = _ref5.accessible,
      theme = _ref5.theme,
      carriers = _ref5.carriers,
      designator = _ref5.designator,
      tripType = _ref5.tripType,
      segments = _ref5.segments,
      depart = _ref5.depart,
      translation = _ref5.translation,
      customProperties = _ref5.customProperties,
      carrierLogoCustomProperties = _ref5.carrierLogoCustomProperties,
      carrierSize = _ref5.carrierSize,
      stopoverSize = _ref5.stopoverSize,
      isViDisclaimer = _ref5.isViDisclaimer,
      isMobile = _ref5.isMobile,
      _ref5$isMobileStyleIn = _ref5.isMobileStyleInDesktop,
      isMobileStyleInDesktop = _ref5$isMobileStyleIn === void 0 ? false : _ref5$isMobileStyleIn,
      containerStyle = _ref5.containerStyle,
      locale = _ref5.locale,
      hourCycle = _ref5.hourCycle,
      isSubjectToGovtApproval = _ref5.isSubjectToGovtApproval,
      useLocalTimezone = _ref5.useLocalTimezone,
      showStackedImages = _ref5.showStackedImages,
      unifiedConfirmationPageProp = _ref5.unifiedConfirmationPageProp;

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];
  /* istanbul ignore next */


  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATIONS), translation);

  var segmentLength = segments.length - 1;
  var flightChangeStatus;
  var flightChangeStatusType;
  segments.forEach(function (segment) {
    if (segment.isFlightScheduleChanged && segment.isFlightScheduleChanged === true) {
      flightChangeStatus = _constant2.TEXT.flightInfo;
      flightChangeStatusType = _constant2.TEXT.rescheduled;
    }
  });

  var _convertSecToHr3 = convertSecToHr(getDurationFromSegments(segments)),
      hour = _convertSecToHr3.hour,
      minute = _convertSecToHr3.minute;

  var _getDays = (0, _Stopover.getDays)(convertUtcToGmt(designator.departureTime, useLocalTimezone), convertUtcToGmt(designator.arrivalTime, useLocalTimezone)),
      day = _getDays.day;

  var stopoverDurations = renderSegmentsToDuration(segments, translation);

  var _ref6 = carrierLogoCustomProperties || {},
      placeHolderBackground = _ref6.placeHolderBackground;

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(SegmentContainer, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties), /*#__PURE__*/_react.default.createElement(SegmentHeader, null, /*#__PURE__*/_react.default.createElement(SegmentHeaderText, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "block",
    theme: theme,
    type: _constant2.TEXT_TYPE.small,
    color: _constant2.COLORS.greyDark,
    bold: true
  }, generateHeaderText({
    carriers: carriers,
    tripType: tripType,
    depart: depart,
    translation: translation
  })), isSubjectToGovtApproval && /*#__PURE__*/_react.default.createElement(ToolTipContainer, {
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    accessible: true,
    asToolTip: false,
    borderRadius: 4,
    bottom: "155%",
    content: /*#__PURE__*/_react.default.createElement(ToolTipContent, null, language.subjectToGovtApproval || _constant2.TRANSLATIONS.subjectToGovtApproval),
    left: isMobileStyleInDesktop || isMobile ? '-280%' : '-14px',
    position: "top",
    right: "auto",
    leftArrow: isMobileStyleInDesktop || isMobile ? '57' : '16',
    theme: theme,
    top: "inherit",
    trigger: _constant2.TRIGGERS.click,
    width: 296,
    zIndex: 1,
    padding: "16px"
  }, /*#__PURE__*/_react.default.createElement(ToolTipIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    theme: theme,
    accessible: accessible,
    color: _constant2.COLORS.yellow,
    fontsize: _constant2.FONT_SIZE.titleSmall,
    icon: _constant2.ICON.warning
  })))), flightChangeStatusType !== undefined && /*#__PURE__*/_react.default.createElement(_Label.default, {
    accessible: true,
    labelColor: flightChangeStatusType === 'CANCELLED' ? _constant2.COLORS.primaryLight : _constant2.COLORS.greenLight,
    textColor: flightChangeStatusType === 'CANCELLED' ? _constant2.COLORS.primaryDark : _constant2.COLORS.green,
    theme: theme,
    customProperties: {
      style: {
        'margin-left': 'auto',
        'margin-right': 0,
        'font-family': 'DM Sans'
      }
    }
  }, flightChangeStatus)), segmentLength > 1 && (isMobileStyleInDesktop || setBreakpoint(windowWidth)) && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "block",
    theme: theme,
    type: _constant2.TEXT_TYPE.small,
    color: _constant2.COLORS.greyDark,
    bold: true
  }, renderSegmentsToDuration(segments, translation))), /*#__PURE__*/_react.default.createElement(SegmentBody, {
    isMobile: isMobile,
    isMobileStyleInDesktop: isMobileStyleInDesktop,
    containerStyle: containerStyle
  }, /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement(_CarrierLogo.default, {
    carriers: carriers,
    size: carrierSize,
    theme: theme,
    accessible: accessible,
    placeHolderBackground: placeHolderBackground,
    customProperties: {},
    showStackedImages: showStackedImages
  })), /*#__PURE__*/_react.default.createElement(FromTo, null, /*#__PURE__*/_react.default.createElement(RenderFromTo, null, renderFromTo(hourCycle, designator, false, accessible, locale, useLocalTimezone, true, unifiedConfirmationPageProp)), /*#__PURE__*/_react.default.createElement(RenderStops, null, /*#__PURE__*/_react.default.createElement(_Stopover.default, {
    designator: designator,
    showText: isMobileStyleInDesktop || setBreakpoint(windowWidth),
    size: stopoverSize,
    segments: segments,
    theme: theme,
    accessible: accessible,
    translation: translation
  })), /*#__PURE__*/_react.default.createElement(RenderFromTo, null, renderFromTo(hourCycle, designator, true, accessible, locale, useLocalTimezone, false, unifiedConfirmationPageProp))), !(isMobileStyleInDesktop || setBreakpoint(windowWidth)) && /*#__PURE__*/_react.default.createElement(SegmentDurationStops, null, /*#__PURE__*/_react.default.createElement(Duration, null, /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    disableActiveState: true,
    hoverBackgroundColor: "default",
    subtitle: "".concat(hour).concat(language.hour, " ").concat(minute).concat(language.minute, " ").concat(day > 0 ? "(+".concat(day, ")") : ''),
    subtitleColor: "greyDark",
    theme: "AIRASIA_CLASSIC",
    titleColor: "neutral",
    subtitleType: "small",
    alignCenter: true,
    unsetPaddingLeft: true,
    width: "80px"
  })), /*#__PURE__*/_react.default.createElement(DetailedStops, null, /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    disableActiveState: true,
    hoverBackgroundColor: "default",
    subtitle: "".concat((0, _Stopover.generateDefaultStopText)(segmentLength, translation)).concat(stopoverDurations ? " (".concat(stopoverDurations, ")") : '', " "),
    subtitleColor: "greyDark",
    theme: "AIRASIA_CLASSIC",
    titleColor: "neutral",
    subtitleType: "small",
    alignCenter: true,
    unsetTextAlignLast: true
  }), isViDisclaimer && /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    disableActiveState: true,
    hoverBackgroundColor: "default",
    subtitle: language.selfTransferRequired,
    subtitleColor: "tertiaryRed",
    theme: theme,
    titleColor: "neutral",
    subtitleType: "small",
    alignCenter: true,
    unsetTextAlignLast: true,
    style: {
      marginTop: '-22px'
    }
  })))), isMobile && isViDisclaimer && /*#__PURE__*/_react.default.createElement(_SectionTile.default, {
    accessible: accessible,
    active: false,
    disableActiveState: true,
    hoverBackgroundColor: "default",
    subtitle: language.selfTransferRequired,
    subtitleColor: "tertiaryRed",
    theme: theme,
    titleColor: "neutral",
    subtitleType: "small",
    style: {
      marginTop: '-16px',
      subtitleTextAlign: 'left',
      marginBottom: '2px'
    }
  })));
};

JourneySegment.propTypes = _JourneySegment.default.PropTypes;
JourneySegment.defaultProps = _JourneySegment.default.DefaultProps;
var _default = JourneySegment;
exports.default = _default;